import React from "react";

function PlayTool(props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1543 21.317V3.68262L20.0005 12.4998L6.1543 21.317ZM7.85244 18.1886L16.8331 12.4998L7.85244 6.81102V18.1886Z"
        fill="#E8EAED"
      />
    </svg>
  );
}

export default PlayTool;
